import { INITIALIZE_STATE_FROM_STORAGE } from '../types';
import storage from '../../../services/storage';
import { loadCart, modifyCart } from '../cart';
import { handleCallback, getToken } from '../auth';
import { getParam } from '../../../utils/url';
import { setCookieFromParam } from '../../../utils/cookies';
import { loadUser } from '../user';
const clearFinalizedOrderFromStorage = () => {
  try {
    const checkoutSessionId = getParam('checkout_session_id');
    const finalizedOrderNumber = getParam('number');
    const cartNumber = storage.getItem('cart-number');
    if (checkoutSessionId && finalizedOrderNumber && finalizedOrderNumber === cartNumber) {
      storage.removeItem('cart-number');
      storage.removeItem('cart-token');
    }
  } catch (error) {
    console.error(error);
  }
};
const persistTrackingParams = () => {
  setCookieFromParam('ir_click_id');
};
export const initializeStateFromStorage = () => {
  const payload = {
    auth: {
      isLoggedIn: storage.getItem('auth-logged-in')
    },
    cart: {
      isFetching: true,
      data: {
        number: storage.getItem('cart-number'),
        token: storage.getItem('cart-token')
      }
    }
  };
  return {
    type: INITIALIZE_STATE_FROM_STORAGE,
    payload
  };
};
export const initializeState = () => {
  return async (dispatch, getState, _ref) => {
    let {
      auth
    } = _ref;
    clearFinalizedOrderFromStorage();
    try {
      await dispatch(initializeStateFromStorage());
    } catch (error) {
      console.error(error);
    }
    try {
      await dispatch(loadCart());
    } catch (error) {
      console.error(error);
    }
    if (auth) {
      // If this function is defined and we are not currently doing the code
      // exchange as a part of the OAuth process, get the token from the auth
      // provider. Newer versions of the auth library generally have a route
      // that does all that handles to code exchange logic isolated from this
      // initialization setup.
      //
      // This method is only available in:
      // chord-magic >= 2.0.0
      // chord-stytch >= 1.1.0
      // chord-cognito-amplify >= 1.1.0
      if (typeof auth.currentUrlHandlesCallback === 'function') {
        // handle newer Magic Link callback
        if (auth.currentUrlHandlesCallback()) {
          const authToken = getParam('magic_credential') || getParam('auth_credential');
          if (authToken) {
            try {
              await dispatch(handleCallback());
            } catch (error) {
              console.error(error);
            }
          } else {
            try {
              await dispatch(getToken());
            } catch (error) {
              console.error(error);
            }
          }
          if (getState().auth.token) {
            try {
              await dispatch(loadUser());
            } catch (error) {
              console.error(error);
            }
          }
        } else {
          try {
            await dispatch(getToken());
          } catch (error) {
            console.error(error);
          }
          if (getState().auth.token) {
            try {
              await dispatch(loadUser());
            } catch (error) {
              console.error(error);
            }
          }
        }
      }
      // Older versions of chord-magic do not support the dedicated callback
      // route. We must maintain compatibility with that library can keep that
      // working.
      else if (typeof auth.currentUrlHandlesCallback === 'undefined') {
        const authToken = getParam('magic_credential') || getParam('auth_credential');
        if (authToken) {
          try {
            await dispatch(handleCallback());
          } catch (error) {
            console.error(error);
          }
        } else {
          try {
            await dispatch(getToken());
          } catch (error) {
            console.error(error);
          }
        }
        if (getState().auth.token) {
          try {
            await dispatch(loadUser());
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
    const referralIdentifier = getParam('ref');
    if (referralIdentifier) {
      try {
        await dispatch(modifyCart({
          attributes: {
            referralIdentifier
          }
        }));
      } catch (error) {
        console.error(error);
      }
    }
    persistTrackingParams();
  };
};